const Translations = {
  menus: {
    sections: {
      box: {
        title: 'Boxes',
        tabs: {
          UNDEFINED: 'Playlists',
          PLAYLIST: 'Playlists',
          MUSIC: 'Music',
          JINGLE: 'Jingle',
          PROMO: 'Promo',
          VOICE_TRACK: 'Voice Track',
          PODCAST: 'Podcast',
          FILLER: 'Ad Filler'
        }
      }
    }
  },
  sections: {
    stations: {
      title: "Stations list",
    },
    station: {
      name: "Station name",
      title: "Station",
      category: "Category",
      LabelCategory: "Label category",
    },
    tracks: {
      edition: {
        artists: 'Artists',
        bpm: 'BPM',
        styles: 'Styles',
        languages: 'Languages',
        label: 'Label',
        tags: 'Tags'
      },
      removal: {
        title: 'Remove track',
        textSingle: 'Are you sure to remove this track?',
        textMultiple: 'Are you sure to remove these tracks?'
      }
    },
    library: {
      sectionTitle: 'Your files',
      upload: {
        title: 'Upload Files'
      }
    },
    clocks: {
      sectionTitle: 'Clocks',
      details: {
        title: '',
        menu: {},
        subMenu: {},
        actions: {
          edit: 'Edit',
          duplicate: 'Duplicate',
          delete: 'Delete',
          more: 'More...'
        }
      },
      edition: {
        title: 'Edit',
        tabs: {
          basic: { title: 'Basic' },
          constraints: { title: 'Constraints' }
        }
      },
      removal: {
        title: 'Remove clock',
        text: 'Are you sure to remove this clock?'
      }
    },
    similarTracks: {
      sectionTitle: 'Select similar tracks',
      details: {
        title: '',
        menu: {},
        subMenu: {
          clocks: 'Clocks',
          playlists: 'Playlists',
          podcasts: 'Podcasts'
        },
      }
    },
    boxes: {
	  sectionTitle: 'Boxes & Playlists',
      boxes: 'Boxes & Playlists',
      details: {
        title: '',
        menu: {},
        subMenu: {
          clocks: 'Clocks',
          playlists: 'Playlists',
          podcasts: 'Podcasts'
        },
        actions: {
          search: 'Search',
          searchAdvanced: 'Advanced Search',
          edit: 'Edit',
          duplicate: 'Duplicate',
          delete: 'Delete',
          more: 'More...'
        }
      },
      edition: {
        title: 'Edit',
        tabs: {
          basic: { title: 'Basic' },
          constraints: { title: 'Constraints' }
        }
      },
      removal: {
        title: 'Remove box or playlist',
        text: 'Are you sure to remove this box or playlist?'
      },
      removeTracks: {
        titleSingle: 'Remove track from :',
        titlePlural: 'Remove tracks from :',
        textSingle: 'Are you sure to remove this track ?',
        textPlural: 'Are you sure to remove these tracks ?'
      }
    },
    dayTemplates: {
      sectionTitle: 'Day Templates',
      edition: {
        title: 'Edit day template',
        tabs: {
          basic: { title: 'Basic' },
          constraints: { title: 'Constraints' }
        }
      },
      details: {
        title: '',
        menu: {
          schedule: 'Schedule',
          adBreaks: 'Ad Breaks',
          constraints: 'Constraints'
        },
        subMenu: {
          clocks: 'Clocks',
          playlists: 'Playlists',
          podcasts: 'Podcasts'
        },
        actions: {
          edit: 'Edit',
          duplicate: 'Duplicate',
          delete: 'Delete',
          more: 'More...'
        },
        schedule: {
          title: 'Schedule',
          modals: {
            scheduleItem: { title: 'Schedule' },
            removeItem: { title: 'Remove' }
          }
        },
        adBreaks: {
          title: 'Ad Breaks'
        }
      },
      removal: {
        title: 'Remove Day Template',
        text: 'Are you sure to remove this day template?'
      }
    },
    planning: {
      sectionTitle: 'Planning',
      actions: {
        currentMonth: 'This Month'
      },
      source: {
        title: 'Day templates'
      },
      details: {
        title: 'Schedule',
        menu: {
          planning: 'Planning',
          podcasts: 'Podcasts',
          logs: 'logs',
          stats: 'Stats'
        },
        actions: {
          edit: 'Export',
          duplicate: 'Download Planning',
          delete: 'Delete'
        }
      }
    }
  },
  trackTypes: {
    UNDEFINED: 'Undefined',
    PLAYLIST: 'Any',
    MUSIC: 'Music tracks',
    JINGLE: 'Jingle',
    PROMO: 'Promo',
    VOICE_TRACK: 'Voice Track',
    PODCAST: 'Podcast',
    FILLER: 'Ad Filler'
  },
  moods: {
    UNDEFINED: ' ',
    NEGATIVE: '-',
    MEDIUM: '=',
    NEUTRAL: '=',
    POSITIVE: '+'
  },
  genders: {
    UNDEFINED: 'Undefined',
    FEMALE: 'Female',
    MALE: 'Male',
    MIXED: 'Mixed',
    INSTRUMENTAL: 'Instru'
  },
  energies: {
    EMPTY: 'EMPTY',
    QUARTER: 'QUARTER',
    HALF: 'HALF',
    THREE_QUARTER: 'THREE_QUARTER',
    FULL: 'FULL'
  },
  boxTypeFilters: {
    all: 'All',
    musicBoxes: 'Music boxes',
    smartBoxes: 'Smart boxes'
  },
  boxTypes: {
    BOX: 'Box',
    PLAYLIST: 'Playlist',
    SMARTBOX: 'Smartbox'
  },
  buttons: {
    cancel: 'Cancel',
    next: 'Next',
    update: 'Update',
    save: 'Save',
    previous: 'Previous',
    close: 'Close',
    delete: 'Delete',
    deleteAndUnliked: 'Unlink and delete',
    createBox: 'Create a new Box',
    exportContent: 'Export songs list',
    exportZipContent: 'Export songs',
    createClock: 'Create a new Clock',
    createDayTemplate: 'Create a new Day Template',
    doCreateClock: 'Create clock',
    doCreateBox: 'Create Box',
    doCreateDayTemplate: 'Create Day Template',
    doEditDayTemplate: 'Save',
    doEditClock: 'Save',
    doEditBox: 'Save',
    doDeleteBox: 'Delete box',
    doDeleteTracks: {
      single: 'Delete track',
      plural: 'Delete tracks'
    },
    doDeleteClock: 'Delete clock',
    doDeleteDayTemplate: 'Delete Day Template'
  },
  placeholders: {
    color: 'Choose your color',
    trackType: 'Choose a track type',
    name: 'Enter a name'
  },
  labels: {
    name: 'Name',
    color: 'Color',
    trackType: 'Track Type',
    boxType: 'Box Type',
    createdOn: 'Created on',
    artistRepeat: 'Artist Delay (minutes)',
    trackRepeat: 'Track Delay (minutes)',
    errorOccured: 'An error occured'
  }
};

export default Translations;
